<mat-form-field>
  <mat-select
    name="fenetre"
    [(ngModel)]="fenetre"
    placeholder="Filtre Fenétre"
    (selectionChange)="setDataListe()"
    required
  >
    <mat-option *ngFor="let p of listePage" [value]="p.value">{{
      p.text
    }}</mat-option>
  </mat-select>
</mat-form-field>
<ng-template #attente>
  <br />
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div *ngIf="!generaleService.disabled; else attente"></div>
<mat-card>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Text">
        <!-- <mat-form-field >
          <input matInput name="Lg_Codez" 
              #Lg_Code="ngModel" [(ngModel)]="code"
              placeholder="Code">
        </mat-form-field>
      <button (click)="ajouter()" mat-raised-button class="colorGreen">ajouter</button>
       -->

        <div class="display-flex">
          <!-- <angular-editor [config]="editorConfig" name="etex1" placeholder="Fr" [(ngModel)]="textFr">
        </angular-editor> -->
          <div class="txt">
            <angular-editor
              [config]="editorConfig"
              name="tex1"
              placeholder="Fr"
              [(ngModel)]="textFr"
            >
            </angular-editor>
          </div>
          <div class="txt">
            <angular-editor
              [config]="editorConfig"
              name="tex2"
              placeholder="En"
              [(ngModel)]="textEn"
            >
            </angular-editor>
          </div>
          <button
            (click)="enregistrer()"
            [disabled]="generaleService.disabled"
            style="max-height: 40px"
            mat-raised-button
            class="colorGreen"
          >
            Enregistrer
          </button>
        </div>

        <app-liste
          #listeTextComponen
          [showFilter]="false"
          [heightTable]="'400'"
          [displayedColumnsBrut]="columnsText"
          (btnTable)="clickBtnHeat($event)"
        >
        </app-liste>
      </mat-tab>
      <mat-tab label="Image">
        <!-- <mat-form-field >
          <input matInput name="Lg_Code" 
              #Lg_Code="ngModel" [(ngModel)]="code"
              placeholder="Code">
        </mat-form-field> -->
        <mat-form-field>
          <mat-select
            name="fenetre2"
            [(ngModel)]="fenetre"
            placeholder="Filtre Fenétre"
            (selectionChange)="setDataListe()"
            required
          >
            <mat-option *ngFor="let p of listePage" [value]="p.value">{{
              p.text
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <input
          id="input_file"
          style="display: none"
          type="file"
          value="importer"
          name="fghjk"
          [(ngModel)]="file"
          (change)="onChangeImagefile($event)"
        />
        <!-- <button [disabled]="generaleService.disabled" (click)="enregistrerImage()" mat-raised-button class="colorGreen">Enregistrer</button> -->
        <div>
          <img
            [id]="img.File_Id"
            (click)="openFrmImage(img)"
            [src]="img.File_Content"
            class="image-content"
            *ngFor="let img of listeImagesToshow"
          />
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
